export interface IPage {
  _id?: string;
  title: string;
  zones: string;
  content?: string;
  parent_id?: string;
  created?: number;
  createdBy?: string;
  updated?: number;
  updatedBy?: string;
  resolve: string;
  url: string;
}

export enum BlockType {
  header = 'header',
  mobileBurger = 'mobileBurger',
  link = 'link',
  container = 'container',
  image = 'image',
  paragraph = 'paragraph',
  heading = 'heading',
  spacer = 'spacer',
  grid = 'grid',
  login = 'login',
  lazy = 'lazy',
  left_menu = 'left_menu',
  /* TODO:: site-specific blocks */

  cp_page = 'cp_page',
  /* END site-specific blocks */
}

export interface IBlockType {
  _id: BlockType;
  title: string;
}

export interface IBlock {
  _id?: string;
  label: string;
  blockType: BlockType;
  width: string;
  height: string;
  parent?: string;
  parentLabel?: string;
  page: string;
  zones: string;
  order: number;
  props: {[propname: string]: any};
  hasChild: boolean;
}


export interface ICollection {
  _id?: string;
  name: string;
  fields: {[propname: string]: 'string'|'number'|'date'|'ObjectId'|'bool'|'file'|'json'};
  signedCookieCreateRole?: string;
  signedCookieUpdateRole?: string;
}

export interface ICollectionItem {
  _id?: string;
  [propname: string]: string|number|undefined,
}

export interface IUser {
  _id?: string;
  login: string;
  password: string;
  role: string;
  uuid?: string;
}

export interface IFile {
  _id?: string;
  filename: string;
}

export interface IZone {
  id: string;
}

export interface IDocument extends ICollectionItem {
  title: string;
  priority: number;
  description: string;
  zones: string;
  assignee: string;
  state: string;
}

export enum VideoStates {
  draft = 'draft',
  in_review = 'in_review',
  declined = 'declined',
  approved = 'approved'
}

export interface IVideo {
  _id?: string;
  title: string;
  description: string;
  state: VideoStates;
  duration?: number;
  trainer_id?: string;
  cloudflareId?: string;
  hlsUrl?: string;
  dashUrl?: string;
  preview_image?: string;
  created?: number;
  createdBy?: string;
  updated?: number;
  updatedBy?: string;
}

// Music for Cafe - Track interface
export interface ITrack {
  _id?: string;
  title: string;
  description: string;
  cover_image?: string;
  duration?: number;
  audio_url?: string;
  artist: string;
  genres: string[];
  moods: string[];
  bpm?: number;
  visible_for?: string; // 'all' | comma-separated logins (up to 10)
  zones: string;
  created?: number;
  createdBy?: string;
  updated?: number;
  updatedBy?: string;
}

// Music for Cafe - Playlist interface
export interface IPlaylist {
  _id?: string;
  title: string;
  description?: string;
  cover_image?: string;
  is_default?: boolean; // системный плейлист (по умолчанию)
  track_count?: number; // кешированное количество треков
  total_duration?: number; // общая длительность в секундах
  zones: string;
  created?: number;
  createdBy?: string;
  updated?: number;
  updatedBy?: string;
}

// Music for Cafe - Playlist Track relation
export interface IPlaylistTrack {
  _id?: string;
  playlist_id: string;
  track_id: string;
  order: number; // порядок трека в плейлисте
  zones: string;
  created?: number;
  createdBy?: string;
}
